import _capitalize from "lodash/capitalize";
import { BulbIcon, CheckmarkIcon, CodeIcon, CrossCircleIcon, CrossCircleInvertedIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import cx from 'classnames';
import React from 'react';
import { appendClassSuffix } from './utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
const TabIconByMessageType = {
  ASSISTANT: ___EmotionJSX(CrossCircleInvertedIcon, {
    "aria-hidden": true,
    color: "#FF5400"
  }),
  CORRECT: ___EmotionJSX(CheckmarkIcon, {
    "aria-hidden": true,
    color: colors.green
  }),
  HINT: ___EmotionJSX(BulbIcon, {
    "aria-hidden": true,
    color: colors.navy
  }),
  INCORRECT: ___EmotionJSX(CrossCircleIcon, {
    "aria-hidden": true,
    color: colors.orange
  }),
  SOLUTION: ___EmotionJSX(CodeIcon, {
    "aria-hidden": true,
    color: colors.navy
  })
};
export const getTabIcon = feedbackMessageType => TabIconByMessageType[feedbackMessageType];
const Tab = _ref => {
  let {
    feedbackMessage,
    onClick
  } = _ref;
  return ___EmotionJSX("li", {
    className: "dc-sct-feedback__tab-container"
  }, ___EmotionJSX("button", {
    "aria-label": _capitalize(feedbackMessage.messageType),
    className: cx('dc-sct-feedback__tab', appendClassSuffix('dc-sct-feedback__tab', feedbackMessage.messageType), {
      'dc-sct-feedback__tab--active': feedbackMessage.isActive
    }),
    onClick: onClick
  }, getTabIcon(feedbackMessage.messageType)));
};
const Tabs = _ref2 => {
  let {
    feedbackMessages,
    onClickTab
  } = _ref2;
  return ___EmotionJSX("ul", {
    className: "dc-sct-feedback__tab-list"
  }, feedbackMessages.map(feedbackMessage => ___EmotionJSX(Tab, {
    feedbackMessage: feedbackMessage,
    key: feedbackMessage.messageType + feedbackMessage.tabIndex.toString(),
    onClick: () => onClickTab(feedbackMessage.tabIndex)
  })));
};
export default Tabs;